const toggleShowAccordionData = (event) => {
    event.preventDefault();
    const header = event.target;
    const container = header.closest(".coop-fnc-accordion-section-container");
    const content = container.getElementsByClassName("accordion-content")[0];

    if (content.classList.contains("visible") === true) {
        content.classList.add("hidden");
        content.classList.remove("visible");
        header.classList.add("closed");
        header.classList.remove("open");
        header.setAttribute("aria-expanded", "false")
    } else {
        content.classList.add("visible");
        content.classList.remove("hidden");
        header.classList.add("open");
        header.classList.remove("closed");
        header.setAttribute("aria-expanded", "true")
    }
};

export const initialiseAccordionSections = () => {
    document.querySelectorAll(".coop-fnc-accordion-section-container .accordion-header").forEach((accordion) => {
        accordion.addEventListener('click', toggleShowAccordionData);
    });
}